module.exports = __webpack_public_path__ + "static/media/GIEvent.9770fa19.jpg";